
export function convertCamelCaseToNormal(str) {
  // 1. Add a space before capital letters (except the first one)
  const spacedStr = str.replace(/([a-z])([A-Z])/g, "$1 $2");

  // 2. Capitalize the first letter of each word and join them
  const capitalizedStr = spacedStr
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return capitalizedStr;
}
